import { ref, watch } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { useRouter, type RouteLocationNormalizedLoaded } from 'vue-router';

export const useEventStore = defineStore('event', () => {
    const route = useRouter();

    // Event selected
    const eventID = ref<number>(0);

    // we detect change in route and see if it starts with a new eventID
    watch(route.currentRoute, (routechange) => grabEvent(routechange));

    const grabEvent = (routechange: RouteLocationNormalizedLoaded) => {
        if (routechange.params['eventID']) {
            const newid = parseInt(routechange.params['eventID'].toString());
            const oldId = eventID.value;
            if (newid != oldId) {
                eventID.value = newid;

                // TODO: We change the ID. For now we reload the entire page, but in the future we need to find all the places we subscribe and unsubscribe and subscribe again.
                if (oldId > 0) {
                    document.location.reload();
                }
            }
        }
    };

    // have we parsed the route yet?
    const initpromise = ref(
        new Promise<void>((resolve) => {
            grabEvent(route.currentRoute.value);
            resolve();
        }),
    );

    return {
        eventID,
        initpromise,
    };
});

/**
 * A reactive reference to the event store.
 * @returns
 */
export const useEventStoreRef = () => storeToRefs(useEventStore());
